import React from "react";
import point from "./../../../../../Images/point.png";

const KeratinHairTreatmentTips = () => {
  return (
    <div className="blogWhat-content">
      <h5>Keratin Hair Treatment Process</h5>

      <p>The keratin treatment process typically includes:</p>

      <ul>
        <li>
          <span>
            <img src={point} alt="point" />
            Hair consultation and analysis
          </span>
        </li>

        <li>
          <span>
            <img src={point} alt="point" />
            Deep cleansing shampoo
          </span>
        </li>

        <li>
          <span>
            <img src={point} alt="point" />
            Application of keratin solution
          </span>
        </li>

        <li>
          <span>
            <img src={point} alt="point" />
            Blow drying and heat sealing
          </span>
        </li>

        <li>
          <span>
            <img src={point} alt="point" />
            Final styling
          </span>
        </li>
      </ul>

      <p>
        This process ensures that the keratin penetrates deeply into the hair
        structure for long-lasting results.
      </p>

      <h5>Keratin Treatment Price in Bangalore</h5>

      <p>
        The keratin treatment price in Bangalore varies depending on hair
        length, thickness, and product quality.
      </p>

      <p>Approximate price range:</p>

      <ul>
        <li>
          <span>
            <img src={point} alt="point" />
            Short Hair: ₹4,000 – ₹6,000
          </span>
        </li>

        <li>
          <span>
            <img src={point} alt="point" />
            Medium Hair: ₹6,000 – ₹10,000
          </span>
        </li>

        <li>
          <span>
            <img src={point} alt="point" />
            Long Hair: ₹10,000 – ₹18,000+
          </span>
        </li>
      </ul>

      <p>
        At SCENT, we provide transparent pricing with premium service quality.
      </p>

      <h5>How Long Does Keratin Treatment Last?</h5>

      <p>
        A keratin hair treatment in Bangalore typically lasts between 3 to 6
        months with proper aftercare.
      </p>

      <p>Aftercare tips:</p>

      <ul>
        <li>
          <span>
            <img src={point} alt="point" />
            Use sulfate-free shampoo
          </span>
        </li>

        <li>
          <span>
            <img src={point} alt="point" />
            Avoid frequent washing
          </span>
        </li>

        <li>
          <span>
            <img src={point} alt="point" />
            Minimize heat styling
          </span>
        </li>

        <li>
          <span>
            <img src={point} alt="point" />
            Use conditioner regularly
          </span>
        </li>
      </ul>

      <h5>Who Should Get Keratin Treatment?</h5>

      <p>Keratin treatment is ideal for:</p>

      <ul>
        <li>
          <span>
            <img src={point} alt="point" />
            Frizzy or dry hair
          </span>
        </li>

        <li>
          <span>
            <img src={point} alt="point" />
            Unmanageable hair
          </span>
        </li>

        <li>
          <span>
            <img src={point} alt="point" />
            Chemically treated hair
          </span>
        </li>

        <li>
          <span>
            <img src={point} alt="point" />
            People who want smooth and shiny hair
          </span>
        </li>
      </ul>
    </div>
  );
};

export default KeratinHairTreatmentTips;